import IndexLayout from '../layouts';
import Wrapper from '../components/Wrapper';
import SiteNav from '../components/header/SiteNav';
import { SiteHeader, outer, inner, SiteMain } from '../styles/shared';
import * as React from 'react';
import { css } from '@emotion/core';
import { colors } from '../styles/colors';

import { PostFullHeader, PostFullTitle, NoImage, PostFull } from '../templates/post';
import { PostFullContent } from '../components/PostContent';
import Footer from '../components/Footer';
import Helmet from 'react-helmet';

// @ts-ignore
import Image from '../content/img/git-commits.png';
// @ts-ignore
import ImageTwo from '../content/img/git-commits2.png';
// @ts-ignore
import ImageThree from '../content/img/git-commits3.png';

const PageTemplate = css`
  .site-main {
    background: #fff;
    padding-bottom: 4vw;

    img {
      width: 100%;
    }

    .color-red {
      color: #d70000;
    }
  }
`;

const Git: React.FunctionComponent = () => (
  <IndexLayout>
    <Helmet>
      <title>Git Flow</title>
    </Helmet>
    <Wrapper css={PageTemplate}>
      <header css={[outer, SiteHeader]}>
        <div css={inner}>
          <SiteNav />
        </div>
      </header>
      <main id="site-main" className="site-main" css={[SiteMain, outer]}>
        <article className="post page" css={[PostFull, NoImage]}>
          <PostFullHeader>
            <PostFullTitle>Proces pracy z Gitem</PostFullTitle>
          </PostFullHeader>

          <PostFullContent className="post-full-content">
            <div className="post-content">
              <p>
                Każdy projekt posiada swoje repozytorium Git założone na BitBuckecie (user: <a href="https://bitbucket.org/snowflakers/">snowflakers</a>). Wszystkie firmowe repozytoria zawsze muszą być <b>prywatne</b> i przypisane do tego konta.
              </p>

              <p>
                Każde repo powinno mieć 2 główne branche: <b>master</b> oraz <b>develop</b>. Oba muszą zawsze posiadać taki sam stan pod względem modyfikacji. Muszą być identyczne.
              </p>

              <p>
                Jeżeli merge'ujesz jakieś zmiany do brancha <b>develop</b>, musi być on niezwłocznie zmerge'owany do <b>master</b>.
              </p>
              
              <p>
                Jeżeli jako developer masz za zadanie napisać nową funkcjonalność lub np. poprawić jakiś bug w aplikacji, twórz nowy branch z brancha <em>develop</em> o nazwie z prefiksem <em>develop</em> i pojedynczym podkreślnikiem, np. <b>develop_menu-bug-fix</b>, <b>develop_module-a-development</b>.
              </p>

              <p class="color-red">
                W przypadku operacji "pójścia live" ze zmianami, Twój roboczy branch (np. wspomniany <b>develop_menu-bug-fix</b>) powinien być najpierw zmerge'owany do <b>develop</b>, a następnie branch <b>develop</b> do <b>master</b>.
              </p>

              <p>
                W naszym zespole nie ma obowiązkowego <b>Code Review, nie mniej jednak robimy je często i praktycznie zawsze po zakończeniu danego etapu pracy nad projektem/funkcjonalnością.</b> Kierujemy się zasadą, że kod należy pielęgnować jak ogród - nawet jeśli nie będzie Code Review przed wypuszczeniem funkcjonalności na produkcję, developer, który zauważy po czasie w danym fragmencie kodu problem lub element, który wymaga poprawy - powinien zaproponować poprawkę.
              </p>

              <p>
                Jako developer, aby poprosić o Code Review, stwórz Pull Request i oznacz inną osobę z Twojego działu, którą chciałbyś poprosić o przejrzenie kodu. PR powinien oznaczać branch develop jako docelowy branch, do którego dany branch ma być zmerge'owany.<br /><br />
                Zaznaczaj opcję <b>Close branch</b> podczas tworzenia PR, aby w momencie zmerge'owania brancha, został on usunięty.<br /><br />
                <b>Pamiętaj, aby prosić o Code Review <u>rozsądnie</u></b> - jeśli np. miałeś do poprawy literówkę albo prostą zmianę w interfejsie, co nie spowoduje problemu dla biznesu i która jednocześnie <span>od razu ma się pojawić na produkcji</span> - po prostu działaj i merguj do develop / master! Proś o Code Review, kiedy rzeczywiście wymaga tego sytuacja.
              </p>

              <p>
                Commitując zmiany, pamiętaj o krótkim, acz treściwym opisie (commit message). Nie chodzi o to, abyś pisał elaborat, ale abyś zwięźle opisał zmiany, z myślą o innych developerach, skupiając się na tym, aby opis był dla nich zrozumiały.
              </p>

              <figure>
                <img src={Image} alt="Commit messages - przykład" />
              </figure>

              <p>
                Aby ułatwić pracę innym developerom, z którymi pracujesz równocześnie nad danym projektem, stosuj oznaczanie flagami w opisie commit'a, dając tym samym znać, czy wymagane są dodatkowe operacje do wykonania (np. instalacja paczki przez NPM, Composera) lub co zawiera się w commit'cie. Przykład:
              </p>

              <figure>
                <img src={ImageTwo} alt="Commit messages - przykład z flagami" />
              </figure>
              <figure>
                <img src={ImageThree} alt="Commit messages - przykład z flagami" />
              </figure>

              <p>
                <b>Znaczenie najpopularniejszych flag:</b><br />
                <ul>
                  <li>[NPM] - wymagana instalacja paczki przez NPM (`npm install`)</li>
                  <li>[C] - wymagana instalacja paczki przez Composera (`composer install`)</li>
                </ul>
              </p>

              <p>
                Podczas początkowej fazy projektu nasi front-end developerzy zaczynając projekt samodzielnie, tworzą czasem główny branch <b>frontend</b>, z którego tworzą branche odpowiadające danej funkcjonalności, nad którą pracują. W dalszej fazie developmentu i tak branch frontend jest merge'owany do głownego brancha develop.
              </p>
              <p>
                Jeżeli nad danym zadaniem będziesz pracował wspólnie z innym członkiem zespołu, dobrze jest zakomunikować nazwę brancha, uzgodnić wcześniej plan (np. o wspólnym merge'owaniu do jednego brancha, na którym znajdzie się zaplanowany zakres funkcjonalności/poprawek). <b>Kluczem zawsze jest komunikacja!</b>
              </p>
            </div>
          </PostFullContent>
        </article>
      </main>
      <Footer />
    </Wrapper>
  </IndexLayout>
);

export default Git;
